import { InitialDataAggregation, ProjectVariation } from 'model';
import { AsyncThunk, EntityId } from '@reduxjs/toolkit';
import {
  createAdapterSelectors,
  createEntitySlice,
  CustomThunk
} from '../../../redux/enitySlice';
import { EntityAPI } from '../../../redux/entity-api.hook';
import { projectVariationsThunk } from './project-variantions.thunk';
import { fetchInitialDataThunk } from '../../../redux/initial-data.thunk';

const { list, delete: deleteThunk, ...thunks } = projectVariationsThunk;

const projectVariationsSlice = createEntitySlice<ProjectVariation>(
  'project-variations',
  [
    CustomThunk.override<ProjectVariation>(list, {
      pending: (_, state) => {
        state.state = 'pending';
        state.listFetched = undefined;
        state.error = null;
        return state;
      },
      rejected: (_, state, action) => {
        state.state = 'idle';
        state.listFetched = false;
        state.error = (action as any).error;
        return state;
      },
      fulfilled: (adapter, state, { payload }) => {
        state.state = 'idle';
        state.listFetched = true;
        return adapter.upsertMany(state, payload as ProjectVariation[]);
      }
    }),
    CustomThunk.override<ProjectVariation>(
      deleteThunk as AsyncThunk<EntityId, { id: EntityId }, any>,
      {
        fulfilled: (adapter, state, { payload }) => {
          state.state = 'idle';
          return adapter.removeOne(state, payload as string);
        }
      }
    ),
    CustomThunk.override<any>(fetchInitialDataThunk, {
      pending: (_, state) => {
        return state;
      },
      rejected: (_, state) => {
        return state;
      },
      fulfilled: (adapter, state, { payload }) => {
        const dataPayload = payload as InitialDataAggregation;
        if (dataPayload.projectVariations) {
          state.state = state.state === 'fresh' ? 'idle' : state.state;
          state.listFetched = true;
          return adapter.upsertMany(state, dataPayload.projectVariations);
        }
        return state;
      }
    }),
    ...Object.values(thunks)
  ]
);
export const projectVariationsSelectors = createAdapterSelectors(
  'project-variations',
  projectVariationsSlice.adapter
);

export const projectVariationAPI: EntityAPI<ProjectVariation> = {
  selectors: projectVariationsSelectors,
  thunks: projectVariationsThunk
};
export default projectVariationsSlice;
